const numericallySortObject = (object: any) => {
  const resortedObject = object;
  for (let i = 1; i < resortedObject.length; i++)
    for (let j = 0; j < i; j++)
      if (resortedObject[i].id < resortedObject[j].id) {
        const x = resortedObject[i];
        resortedObject[i] = resortedObject[j];
        resortedObject[j] = x;
      }
  return resortedObject;
};

export const numericallySortAlerts = (streams: any, string: any) => {
  const sortedStreams = streams;
  sortedStreams.forEach((object: any, index: any) => {
    const sortedObject = object;
    if (string === "sureview_alerts") {
      const numericalSureviewAlerts = sortedObject.sureview_alerts;
      numericallySortObject(numericalSureviewAlerts);
      sortedObject.sureview_alerts = numericalSureviewAlerts;
    }
    if (string === "immix_alerts") {
      const numericalImmixViewAlerts = sortedObject.immix_alerts;
      numericallySortObject(numericalImmixViewAlerts);
      sortedObject.immix_alerts = numericalImmixViewAlerts;
    }
    sortedStreams[index] = sortedObject;
  });
  return sortedStreams;
};

export const matchAllStreams = (streams: any, string: any) => {
  const sortedStreams = streams;
  if (string === "sureview_alerts") {
    const comparedArray = streams[0].sureview_alerts;
    sortedStreams.forEach((object: any, sortedStreamsIndex: any) => {
      const originalAlerts = object.sureview_alerts;
      const newlySortedAlerts = new Array(originalAlerts.length);

      originalAlerts.forEach((alertObject: any) => {
        for (let i = 0; i < comparedArray.length; i++) {
          if (
            alertObject.sureview_server === comparedArray[i].sureview_server &&
            alertObject.sureview_subject ===
              comparedArray[i].sureview_subject &&
            alertObject.sureview_cc === comparedArray[i].sureview_cc &&
            alertObject.sureview_email === comparedArray[i].sureview_email
          ) {
            newlySortedAlerts[i] = alertObject;
            break; // Found the correct position, no need to continue searching
          }
        }
      });

      // Fill any remaining empty slots with remaining alerts
      let remainingIndex = 0;
      for (let i = 0; i < newlySortedAlerts.length; i++) {
        if (!newlySortedAlerts[i]) {
          while (
            remainingIndex < originalAlerts.length &&
            newlySortedAlerts.includes(originalAlerts[remainingIndex])
          ) {
            remainingIndex++;
          }
          if (remainingIndex < originalAlerts.length) {
            newlySortedAlerts[i] = originalAlerts[remainingIndex];
            remainingIndex++;
          }
        }
      }

      sortedStreams[sortedStreamsIndex].sureview_alerts = newlySortedAlerts;
    });
    return sortedStreams;
  }

  if (string === "immix_alerts") {
    const comparedArray = streams[0].immix_alerts;
    sortedStreams.forEach((object: any, sortedStreamsIndex: any) => {
      const originalAlerts = object.immix_alerts;
      const newlySortedAlerts = new Array(originalAlerts.length);

      originalAlerts.forEach((alertObject: any) => {
        for (let i = 0; i < comparedArray.length; i++) {
          if (
            alertObject.immix_server === comparedArray[i].immix_server &&
            alertObject.immix_port === comparedArray[i].immix_port &&
            alertObject.immix_email === comparedArray[i].immix_email &&
            alertObject.immix_input1 === comparedArray[i].immix_input1
          ) {
            newlySortedAlerts[i] = alertObject;
            break; // Found the correct position, no need to continue searching
          }
        }
      });

      // Fill any remaining empty slots with remaining alerts
      let remainingIndex = 0;
      for (let i = 0; i < newlySortedAlerts.length; i++) {
        if (!newlySortedAlerts[i]) {
          while (
            remainingIndex < originalAlerts.length &&
            newlySortedAlerts.includes(originalAlerts[remainingIndex])
          ) {
            remainingIndex++;
          }
          if (remainingIndex < originalAlerts.length) {
            newlySortedAlerts[i] = originalAlerts[remainingIndex];
            remainingIndex++;
          }
        }
      }

      sortedStreams[sortedStreamsIndex].immix_alerts = newlySortedAlerts;
    });
  }
  return sortedStreams;
};
